export default __webpack_public_path__ + "static/media/donatewavebtm.506a8942.png";